// CMS phone fields use Brazilian DDD + number, optionally prefixed with country code 55.
// Never infer a missing DDD or turn a local-only number into a clickable destination.
export function whatsappLink(value) {
  const phone = String(value ?? '').trim();
  if (!phone || /[a-z]/i.test(phone)) return '';
  const digits = phone.replace(/\D/g, '');
  if (/^\d{10,11}$/.test(digits) && !phone.startsWith('+')) return `https://wa.me/55${digits}`;
  if (/^55\d{10,11}$/.test(digits)) return `https://wa.me/${digits}`;
  return '';
}
